export const WEBSOCKET_CONNECT = 'WEBSOCKET_CONNECT';
export const WEBSOCKET_DISCONNECT = 'WEBSOCKET_DISCONNECT';
export const WEBSOCKET_CONNECTED = 'WEBSOCKET_CONNECTED';
export const WEBSOCKET_DISCONNECTED = 'WEBSOCKET_DISCONNECTED';
export const SET_WEBSOCKET_METHODS = 'SET_WEBSOCKET_METHODS';

export const connectWebSocket = (url, token) => ({
  type: WEBSOCKET_CONNECT,
  payload: { url, token },
});

export const disconnectWebSocket = () => ({
  type: WEBSOCKET_DISCONNECT,
});

export const websocketConnected = () => ({
  type: WEBSOCKET_CONNECTED,
});

export const websocketDisconnected = () => ({
  type: WEBSOCKET_DISCONNECTED,
});

export const setWebSocketMethods = (methods) => ({
  type: SET_WEBSOCKET_METHODS,
  payload: methods,
});
